import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {useContext} from "react";
import ModalContext from "./envResultsTable/ModalContext";
import styled from "styled-components";
import CancelIcon from "../../assets/createEnvAssets/CancelIcon";
import {style} from "./BasicModal"


const CancelButtonWrapper = styled.div`
  display: flex;
  justify-content: end;

  .cancel_button {
    width: 10px;
    cursor: pointer;
  }
`;

const MessageContent = styled.p`
  font-size: 13px;
`;

const MessageWrapper = styled.div`
  padding: 10px;
`;

const Button = styled.button`

  width: 155px;
  background: var(--color-brand-pink-primary);
  color: white;
  border: 1px solid var(--color-createenv-form-btn-border);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  display: inline;

  &:hover {
    background: #fa105b;
  }
`;


export default function DeleteEnvModal() {
    const {
        deleteEnvModalIsOpen,
        setDeleteEnvModalIsOpen,
        contentMessage,
        setContentMessage,
        setDeleted,
        isEnvActive,
    } = useContext(ModalContext);
    const handleClose = () => {
        setDeleteEnvModalIsOpen(false)
        setContentMessage("");
        setDeleted(false);
    }
    const handleDelete = () => {
      setDeleteEnvModalIsOpen(false);
      setContentMessage("");
      setDeleted(true);
    };
    return (
        <div>
            <Modal
                open={deleteEnvModalIsOpen}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} id={"delete-env-modal"}>
                    <CancelButtonWrapper>
                                <span className={"cancel_button"} onClick={handleClose}>
                                    <CancelIcon/>
                                </span>
                    </CancelButtonWrapper>
                    <MessageWrapper id={"message-wrapper"}>
                        <MessageContent  id={"first-message"}>{contentMessage[0]}</MessageContent>
                    </MessageWrapper>
                    {!isEnvActive ? <Button id={"clear-record"} onClick={handleDelete}>Clear Record</Button> :
                        <Button id={"ok"} onClick={handleClose}>OK</Button>}
                </Box>
            </Modal>
        </div>
    );
}
